import uuid from 'uuid/v4'
import moment from 'moment-timezone'
import html2canvas from 'html2canvas'
import constants from './constants'
import countryList from './country'
// import JsPDF from 'jspdf'

const allowedCountryCodes = countryList
  .map(country => country.code.replace('+', ''))
  .join('|');

export function generateRequestId() {
  const prefix = 'BO'
  const time = moment().format('YYMMDDHHmmss')
  // Take the last set of characters of uuid and capitalize
  const uuidStr = uuid()
    .split('-')
    .slice(-1)
    .toString()
    .toUpperCase()
  return `${prefix}-${time}-${uuidStr}`
}

export function isPhoneNumber(phone) {
  return /^(?:\+\d{1,3}-?|\b0{0,2}(\d{1,3})-?)?\d{6,15}$/.test(phone.replace(/\s+/g, ''))
}

export function getCountryCodeAndPhone(phone: string): { countryCode: string; phoneNumber: string } {
  const regexStr = new RegExp(`^(?:\\+(${allowedCountryCodes})-?|\\b(?:0{0,2}(${allowedCountryCodes})-?))?`);
  const match = phone.match(regexStr);
  let countryCode: string = '';
  if (match) {
    const matchedCode = match[1] || match[2];
    countryCode = matchedCode ? `+${matchedCode}` : '';
  }
  const phoneNumber = match ? phone.replace(match[0], '') : phone;
  return {
    countryCode: countryCode || '',
    phoneNumber: phoneNumber || ''
  };
}

export function formatNumber(num) {
  let v
  if (typeof num === 'number') {
    v = num
  } else if (typeof num === 'string') {
    v = Number(num)
  } else {
    return num
  }
  v = Math.round(v)
  return v.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1.')
}

export function formatCurrency(num) {
  return parseInt(num)
    .toString()
    .replace(/(\d)(?=(?:\d{3})+$)/g, '$1.')
}

export function getEdcMidMapping() {
  const fallback = `${process.env.VUE_APP_EDC_MID_MAPPING || ''}`

  if (typeof window === 'undefined') {
    return fallback
  }

  const stored = window.localStorage.getItem('EDC_MID_MAPPING')
  if (!stored) {
    return fallback
  }

  try {
    const config = JSON.parse(stored)
    const mapping = config.edc_mapping || config.edcMapping || config
    return JSON.stringify(mapping)
  } catch (e) {
    return stored
  }
}

export function unFormatCurrency(string) {
  return string.replace(/\./g, '')
}

export function formatToCurrency(money, currency = 'Rp') {
  return (
    currency +
    ' ' +
    money.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1.')
  )
}

export function getResponseToMTH(
  response,
  swal,
  successMessage,
  errorMessage = constants.SOMETHING_WROING
) {
  if (response.code && response.code === constants.STATUS_200_STRING) {
    swal(successMessage, response.message, constants.STATUS_SUCCESS)
  } else {
    swal(errorMessage, response.data.message, constants.STATUS_ERROR)
    return false
  }
  return true
}

export function getResponseToMTHForNewPort(
  response,
  swal,
  successMessage,
  errorMessage = constants.SOMETHING_WROING
) {
  if (
    (response.status && response.status === constants.STATUS_200) ||
    (response.code && response.code === constants.STATUS_200_STRING)
  ) {
    swal(successMessage, '', constants.STATUS_SUCCESS)
  } else {
    swal(errorMessage, '', constants.STATUS_ERROR)
    return false
  }
  return true
}

export function downloadCSV(data, filename) {
  const fomratDate = date => {
    if (date) {
      return moment(date).format('YY/MM/DD HH:mm')
    } else {
      return ''
    }
  }

  const title = [
    `,Order ID, Billing Order, Billing Status, Promo Discount Value, Promo Discount Type, Promo ID, Promo Name, Order State, Order Type, Order Source, Order Create Time, Order Paid Time, Order Ready to pickup time, Order On Delivery Time, Order Complete Time, Order Canceled Time, Last Update Time, Outlet Code, Outlet Name, Restaurant Address, Items Name, Item Quantity, Rp Unit Price, Tax, Total Amount without tax, Delivery Fee, Delivery Distance, Total Value (without Promo), Promo Userd ID, Promo Value, Actual Payment, Payment Method, Payment Type,  User ID, Qraved User Name, Contact User Name, User Address, User Area, Contact Phone Number, Contact Email, TableNumber, TakeawayNumber, TotalVariantPrice, VariantName, BuildingName, RoomNo, OrderTotalRoomFee, OrderTotalProcessingFee`
  ]

  const handledData = data.map(item => {
    const newItem = `${item.OrderID},${item.BillingOrder},${
      item.BillingStatus
    },${item.PromoDiscountValue},${item.PromoDiscountType},${item.PromoID},${
      item.PromoName
    },${item.Status},${item.OrderType},${item.OrderSource || '-'},${fomratDate(
      item.CreatedAt
    ) || '-'},${fomratDate(item.PaidDate) || '-'},${fomratDate(
      item.ReadyPickupDate
    ) || '-'},${fomratDate(item.OnDeliveryDate) || '-'},${fomratDate(
      item.CompletedDate
    ) || '-'},${fomratDate(item.CancelTime) || '-'},${fomratDate(
      item.UpdateAt
    ) || '-'},${item.OutletCode},${
      item.OutletName
    },${item.OutletAddress.replace(/,/g, ' -')},${item.ItemName.replace(
      /,/g,
      '.'
    )},${item.ItemQty},${item.ItemPrice},${item.OrderTax},${
      item.OrderTotalAmount
    },${item.OrderDeliveryFee},${item.DeliveryDistance},${item.OrderTotal},${
      item.PromoID
    },${item.OrderTotalDiscount},${item.OrderTotalSale},${item.PaymentMethod},${
      item.PaymentOrder
    },${item.UserID || '-'},${item.UserName},${
      item.ContactName
    },${item.UserAddress.replace(/,/g, ' -')},${item.UserArea},${
      item.ContactPhone
    },${item.ContactEmail},${item.TableNumber},${item.TakeawayNumber},${
      item.TotalVariantPrice
    },${item.VariantName.replace(/;/g, ' <-> ')}, ${item.BuildingName.replace(
      /,/g,
      '，'
    )},${item.RoomNo.replace(/,/g, '，')}, ${item.OrderTotalRoomFee}, ${
      item.OrderTotalProcessingFee
    }`
    return newItem.replace(/\n/g, '')
  })

  const downloadData = new Blob(
    // @ts-ignore
    [
      title
        .concat(handledData)
        .join(';\n;')
        .split(';')
    ],
    { type: 'text/csv;charset=utf-8;' }
  )
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(downloadData)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export function downloadOrders(res) {
  const title = [`,${res.data.result.header.join(',')}`]

  const handledData = res.data.result.data.map(v => {
    const newItem = JSON.stringify(v).replace(/\[|]/g, '')
    return newItem.replace(/\n/g, '')
  })

  const downloadData = new Blob(
    // @ts-ignore
    [
      title
        .concat(handledData)
        .join(';\n;')
        .split(';')
    ],
    { type: 'text/csv;charset=utf-8;' }
  )

  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(downloadData)
    link.setAttribute('href', url)
    link.setAttribute('download', 'orderDetail.csv')
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

// export pdf file
export function downloadPDF(ele, pdfName) {
  let topSize = (document as any).documentElement.scrollTop
  if ((document as any).documentElement.scrollTop > 0) {
    ;(document as any).documentElement.scrollTop = (document as any).documentElement.scrollTop = 0
  }
  html2canvas(ele, {
    // @ts-ignore
    dpi: 200,
    useCORS: true
  }).then(canvas => {
    let contentWidth = canvas.width
    let contentHeight = canvas.height
    let pageHeight = (contentWidth / 592.28) * 841.89
    let leftHeight = contentHeight
    let position = 0
    let imgWidth = 595.28
    let imgHeight = (595.28 / contentWidth) * contentHeight
    let pageData = canvas.toDataURL('image/jpeg', 1.0)
    // @ts-ignore
    // let pdf = new JsPDF('', 'pt', 'a4')
    // if (leftHeight < pageHeight) {
    //   pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    // } else {
    //   while (leftHeight > 0) {
    //     pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
    //     leftHeight -= pageHeight
    //     position -= 841.89
    //     if (leftHeight > 0) {
    //       pdf.addPage()
    //     }
    //   }
    // }
    // (document as any).documentElement.scrollTop = (document as any).documentElement.scrollTop = topSize
    // pdf.save(pdfName)
  })
}

export const getRequestId = () => {
  const time = moment().format('YYYYMMDDHHSS')
  const uuidArr = uuid().split('-')
  return `BO-${time}-${uuidArr[uuidArr.length - 1]}`
}

export const getFileName = fileName =>
  String(fileName)
    .split('.')
    .slice(0, -1)
    .join('.')
export const getFileExt = fileName =>
  String(fileName)
    .split('.')
    .pop()
export const getFileNameWithUUID = fileName => {
  const uuidString = uuid()
    .split('-')
    .pop()
  return `${getFileName(fileName)}-${uuidString}.${getFileExt(fileName)}`
}

export const getOrderItemCardIcon = type => {
  let text = ''
  let icon = ''
  switch (type) {
    case constants.PPTA:
      icon = require('@/assets/takeAway.svg')
      text = 'Takeaway'
      break
    case constants.PPDI:
      icon = require('@/assets/dineIn.svg')
      text = 'Dine-In'
      break
    case constants.HMD:
      icon = require('@/assets/delivery.svg')
      text = 'Delivery'
      break
    case constants.TOP:
      icon = require('@/assets/tableOrder.svg')
      text = 'Table Order'
      break
    case constants.OTHERS:
      icon = require('@/assets/Others.svg')
      text = 'Others'
      break
    case constants.ROOM:
      icon = require('@/assets/RoomService.svg')
      text = 'Room'
      break
    case constants.POS:
      icon = require('@/assets/Pos.svg')
      text = 'Pos'
      break
    default:
      icon = require('@/assets/delivery.svg')
      text = 'Delivery'
      break
  }
  return {
    text,
    icon
  }
}
export const showConfirmButton = item => {
  if (
    (item.orderStateMachine === 1 &&
      (item.orderStatus === 'SUBMITTED' ||
        item.orderStatus === 'PAYMENT_SUCCESS') &&
      (item.orderType !== 'ROOM' && item.orderType !== 'HMD')) ||
    (item.orderStatus === 'PAYMENT_SUCCESS' && item.orderType === 'POS')
  ) {
    return true
  }
  return false
}
export const formatCouponText = coupon => {
  if (coupon.discount_type && coupon.discount_value) {
    switch (coupon.discount_type) {
      case 1:
        return coupon.discount_value + '% discount'
      case 2:
        return 'Rp. ' + formatNumber(coupon.discount_value) + ' discount'
    }
  }
  return ''
}
export const formatCouponDate = val => {
  const timestamp = Number(val)
  const date = val !== null && val !== '' && Number.isFinite(timestamp) && timestamp < 1000000000000 ? timestamp * 1000 : val
  return moment(date).isValid() ? moment(date).utc().format('DD MMM YYYY') : val
}
export const isMobile = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}
export const isEDC = () => (
  typeof window !== 'undefined' &&
  typeof (window as any).android !== 'undefined' &&
  typeof (window as any).android.isEDC !== 'undefined'
)
export const calculateLevelInfo = (levels, totalSpend) => {
  let nextLevel;
  let memberLevel = 'Basic';
  let spendToNextLevel = 0;
  let nextLevelName = '';

  if (totalSpend === 0) {
    spendToNextLevel = levels[0].level_from - totalSpend;
    nextLevelName = levels[0].title;
  } else if (totalSpend < levels[0].level_from) {
    spendToNextLevel = levels[0].level_from - totalSpend;
    nextLevelName = levels[0].title;
  } else {
    for (let i = 0; i < levels.length; i++) {
      const level = levels[i];
      const nextLevelIndex = i + 1;

      if (totalSpend >= level.level_from &&
        (nextLevelIndex >= levels.length || totalSpend < levels[nextLevelIndex].level_from)) {
        memberLevel = level.title;

        if (nextLevelIndex < levels.length) {
          nextLevel = levels[nextLevelIndex];
          spendToNextLevel = nextLevel.level_from - totalSpend;
          nextLevelName = nextLevel.title;
        }
        break;
      }
    }
  }

  return {
    memberLevel,
    spendToNextLevel,
    nextLevelName,
    progressAction: spendToNextLevel > 0 ? 'reach' : 'done'
  };
}
